/** Nombre maximum d'itérations d'appels de tools par boucle d'agent */
export const MAX_TOOL_ITERATIONS = 15

/** Budget de thinking (tokens) pour les modèles qui supportent le reasoning */
export const THINKING_BUDGET = 8192

/** Nombre maximum de caractères pour un titre de conversation généré */
export const TITLE_MAX_LENGTH = 80

/** Étapes d'affilée faites uniquement de recherches au-delà desquelles l'étape suivante n'a plus accès à la recherche */
export const MAX_SEARCH_ONLY_STEPS = 3

/** Nombre maximum de caractères pour le titre temporaire (avant génération par le LLM) */
export const TITLE_PREVIEW_LENGTH = 50

/** Nombre maximum de caractères autorisés dans le résumé compact */
export const COMPACT_SUMMARY_MAX_LENGTH = 2_000

/** Contexte (tokens en entrée du dernier appel) au-delà duquel les anciens tours sont résumés */
export const COMPACT_THRESHOLD_TOKENS = 100_000

/** Tours (message utilisateur + réponse) toujours envoyés tels quels au modèle */
export const COMPACT_KEEP_RECENT_TURNS = 2

/** Tours à résumer au minimum avant un (nouveau) résumé : limite les résumés de résumés */
export const COMPACT_MIN_NEW_TURNS = 2
